import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ParentService } from '../parent.service';
import { DeleteDialogComponent } from '../delete-dialog/delete-dialog.component';
import { Md5 } from 'ts-md5';
import { CustomValidator } from '../../parent-App/parentapp-login/custom-from-validators';
@Component({
  selector: 'app-parent-login',
  templateUrl: './parent-login.component.html',
  styleUrls: ['./parent-login.component.scss']
})
export class ParentLoginComponent implements OnInit {
  errorDescription: string;
  loginform!: FormGroup;
  showpassword: boolean = false;
  invalidpassword: boolean = false;
  deactivated: boolean = false;
  logindetails: any;
  isFormInvalid: boolean = false;
  loginError: boolean = false;
  loginserver: boolean = false;
  constructor(private fb: FormBuilder, private dialog: MatDialog, private spinner: NgxSpinnerService, private login: ParentService) { }
  ngOnInit(): void {
    this.loginform = this.fb.group({
      userName: ['', [Validators.required, CustomValidator.numberValidator]],
      password: ['', Validators.required]
    });
  }

  toggleshow() {
    this.showpassword = !this.showpassword;
  }

  // submit() {
  //   if (this.loginform.valid) {
  //     this.isFormInvalid = true;
  //     this.loginError = false;
  //     const pass = {
  //       password: this.loginform.value.password
  //     }
  //     console.log(pass.password);
  //     const passwordmd5 = Md5.hashStr(pass.password).toString();
  //     console.log(passwordmd5);
  //     const payload1 = 'username=' + this.loginform.value.userName + '&password=' + passwordmd5 + '&grant_type=password&app_name=SCEmployee+APP&deviceId=1b07bcb93986ef3c&fcm_id=test123';
  //     console.log("payload", payload1);
  //     this.spinner.show();
  //     this.login.postlogin(payload1).subscribe((res) => {
  //       this.logindetails = res;
  //       this.spinner.hide();
  //       this.isFormInvalid = false;
  //       this.loginform.reset();
  //       console.log("login", this.logindetails);
  //       localStorage.setItem('token', this.logindetails.access_token);
  //       this.dialog.open(DeleteDialogComponent, {
  //         disableClose: true,
  //       });
  //     }, (error: any) => {
  //       this.loginError = true;
  //       this.isFormInvalid = false;
  //       if (error.status === 400) {
  //         console.error('Unauthorized access. Please check your credentials.');
  //         this.loginform.reset();
  //       } else if (error.status === 500) {
  //         this.loginserver = true;
  //         this.loginError = false;
  //         console.error('Internal Server Error');
  //         this.loginform.reset();
  //       } else {
  //         console.error('Login failed:', error)
  //       }
  //     });
  //   } else {
  //     this.isFormInvalid = true;
  //   }



  // }

  submit() {
    if (this.loginform.valid) {
      this.isFormInvalid = true;
      this.invalidpassword = false;
      const pass = {
        password: this.loginform.value.password
      }
      const passwordmd5 = Md5.hashStr(pass.password).toString();
      // const payload1 = 'username=' + this.loginform.value.userName + '&password=' + passwordmd5 + '&grant_type=password&app_name=SCEmployee+APP&deviceId=1b07bcb93986ef3c&fcm_id=test123';
      const payload1 = {
        admNo: this.loginform.value.userName,
        password: passwordmd5,
        platform: "web"
      }
      this.spinner.show();
      this.login.postlogin(payload1).subscribe(
        {
          next: (res: any) => {
            if (!res) {
              this.spinner.hide();
            }
            this.logindetails = res;
            // console.log('logindetails', this.logindetails);
            this.spinner.hide();
            this.isFormInvalid = false;
            this.loginform.reset();
            // console.log("login", this.logindetails);
            localStorage.setItem('token', this.logindetails.jsonV2.accessToken);
            localStorage.setItem('admNo', this.logindetails.jsonV2.admNo);
            localStorage.setItem('deviceSessionId', this.logindetails.jsonV2.deviceSessionId);
            localStorage.setItem('tokenRefreshKey', this.logindetails.jsonV2.tokenRefreshKey);
            localStorage.setItem('loginTime', this.logindetails.jsonV2.loginTime);
            localStorage.setItem('time', this.logindetails.jsonV2.tokenValidTime);
            if (this.logindetails.jsonV2.accessKey === true) {
              this.deactivated = false;
              this.errorDescription = '';
              this.dialog.open(DeleteDialogComponent, {
                disableClose: true,
              });
            }
            else {
              //change the deactivated true //
              this.deactivated = true;
              this.invalidpassword = false;
            }
          }, error: (error: any) => {
            // console.log("error_description", error.error.message);
            this.errorDescription = error.error.message;
            this.loginform.reset();
            this.deactivated = false;
            this.isFormInvalid = false;
            this.spinner.hide();
            if (error.error_description === 400) {
              // console.error('Unauthorized access. Please check your credentials.');
              this.loginform.reset();
            } else if (error.status === 500) {
              this.loginserver = true;
              this.invalidpassword = false;
              this.deactivated = false;
              // console.error('Internal Server Error');
              this.loginform.reset();
            }
          },
          complete: () => {
            // console.log('completed!');
          }
        }
      );
    } else {
      this.isFormInvalid = true;
      this.invalidpassword = false;
    }
  }

}
